import type { User } from '../../core/models/data';

export type UserScopedWritePayload = {
  userId: string; // internal user doc id only
};

export const getCurrentUserIdentityIds = (currentUser: Pick<User, 'id' | 'authUid'> | null | undefined): string[] => {
  if (!currentUser) return [];
  return Array.from(new Set([currentUser.id, currentUser.authUid].filter((value): value is string => typeof value === 'string' && value.trim().length > 0))).slice(0, 10);
};

export const normalizeUserIdForWrite = (currentUser: Pick<User, 'id' | 'authUid'>): string => {
  const userId = currentUser.id;
  if (import.meta.env.DEV && currentUser.authUid && userId === currentUser.authUid) {
    console.warn('INVALID WRITE: authUid used instead of internal userId');
  }
  if (import.meta.env.DEV) {
    console.debug('write identity:', { userId, authUid: currentUser.authUid ?? null });
  }
  return userId;
};
